import { makeStyles } from "../shared";
export const recordingStyles = makeStyles({
  loginHintLink: {
    margin: "0px 3px 0px 3px",
  },
});
